import { render, staticRenderFns } from "./subCategory.vue?vue&type=template&id=089f355e&"
import script from "./subCategory.vue?vue&type=script&lang=js&"
export * from "./subCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports